import React from 'react';
import { css } from '@emotion/react';
import { Helmet } from "react-helmet";

import theme from "../../theme";
import { getSiteTitle, MANAGE_URL } from "../../config/config";
import Button from "../components/Button";

const PaymentSuccess: React.FC = () => {

    const onStartNow = () => {
        window.location.href = MANAGE_URL;
    }

    return (
        <div css={content}>
            <Helmet>
                <title>{getSiteTitle("Payment Successful")}</title>
                <meta
                    name="description"
                    content="Thanks for signing up for a free trial of Writer’s Toolbox! You’ve taken the first step to helping your child master the skills of great writing."
                />
            </Helmet>
            <h1 css={headerStyle}>Thanks for signing up for a free trial of Writer’s Toolbox!</h1>
            <div css={textStyle}>
                <p>
                    Congratulations! Watch your child’s confidence and grades improve as they master sentence and
                    paragraph design, essay writing, grammar, and more.
                </p>
                <p>
                    Click the button below to enter the world of Writer’s Toolbox.
                </p>
            </div>
            <Button type="button" onClick={onStartNow} color={"secondary"}>Start now</Button>
            <div css={letTheJourneyBeginStyle}>Let the journey begin!</div>
        </div>
    );
};

const content = css`
    width: 100%;
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: ${theme.fonts.frutiger};
    text-align: center;
`;

const headerStyle = css`
    font-size: 30px;
    color: ${theme.colours.denim};
    line-height: 42px;
    font-weight: 600;
    margin-top: 10px;
`;

const textStyle = css`
    font-size: 18px;
    color: ${theme.colours.denim};
    line-height: 24px;
    margin-top: 10px;
    margin-bottom: 12px;

    p {
        padding: 8px 0;
    }
`;

const letTheJourneyBeginStyle = css`
    ${textStyle};
    margin-top: 20px;
`;

export default PaymentSuccess;
